import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-building-fabric',
  templateUrl: './building-fabric.component.html',
  styleUrls: ['./building-fabric.component.scss'],
})
export class BuildingFabricComponent implements OnInit {

  constructor() {}

  ngOnInit() {}
}
